/* global axios */
import ApiClient from '../ApiClient';

class PilotAssistantCustomTools extends ApiClient {
  constructor() {
    super('pilot/assistants', { accountScoped: true });
  }

  get(assistantId) {
    return axios.get(`${this.url}/${assistantId}/custom_tools`);
  }

  create(assistantId, customToolId) {
    return axios.post(`${this.url}/${assistantId}/custom_tools`, {
      custom_tool_id: customToolId,
    });
  }

  delete(assistantId, customToolId) {
    return axios.delete(
      `${this.url}/${assistantId}/custom_tools/${customToolId}`
    );
  }
}

export default new PilotAssistantCustomTools();
